import React from 'react';
import styled from 'styled-components';
import __ from '../utils/translator';

export default styled.span.attrs({
  title: __('Draft'),
})`
  display: inline-block;
  width: .5rem;
  height: .5rem;
  background-color: #cc1616;
  border-radius: 50%;
`;
